import styled from 'styled-components';

import { Button as CustomButton } from '../../Button';

export const Button = styled(CustomButton)`
  && {
    margin-left: 1vw;
    margin-right: 0 !important;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0.5px;
  }

  .anticon {
    top: 1px;
    position: relative;
    margin-right: 8px;
  }

  @media (max-width: 1400px) {
    && {
      font-size: 13px;
      margin-left: 0.5vw;
      letter-spacing: 0;
    }
  }

  @media (max-width: 767px) {
    &.header-trigger {
      display: none;
    }
  }

  @media (orientation: landscape) and (max-width: 1030px) {
    && {
      margin-left: calc(16px / var(--html-zoom, 1));
    }

    html.zoom-lg && {
      .anticon {
        margin-right: 0;
      }
    }
  }
`;

export const LabelFull = styled.span`
  @media (max-width: 1400px) {
    display: none;
  }
`;

export const LabelShort = styled.span`
  display: none;

  @media (max-width: 1400px) {
    display: inline;
  }

  @media (orientation: landscape) and (max-width: 1030px) {
    html.zoom-lg & {
      display: none;
    }
  }
`;
